import React, {useState} from "react";
import { Icon, Grid } from "semantic-ui-react";
import './Optionsbar.css'
import axios from "axios";
import { useSelector, useDispatch } from "react-redux";
import { setDatabase, setMenuEnabled, getSecurityKey, setMetricsTable } from "../../features/tableData/visualSlice";
import Explorerbar from "../Explorerbar/Explorerbar";
import { Image } from "semantic-ui-react";
import logo from "../../logo.png";
import { getDatabases } from "../../features/tableData/visualSlice";


const Optionsbar = () => {
  const [activeIndex, setActiveIndex] = useState(0);
  const securityKey = useSelector(getSecurityKey);
  const databases = useSelector(getDatabases);
  const handleClick = (index,callBackFunc) => {
    // console.log(index);
    setActiveIndex(index);
    callBackFunc();
  }
  const dispatch = useDispatch();
  const activateDatabaseMenu = () => {
    const promise = axios.get(`${process.env.REACT_APP_BACKEND_URL}/get_databases_info`, {params : {securityKey: securityKey}});
    promise.then((response) => {
        console.log(response.data);
        dispatch(setDatabase(response.data));
      },
      (error) => {
        console.log(error);
      }
    );
    dispatch(setMenuEnabled("database"));
  }

  const activateHomeMenu = () => {
    dispatch(setMenuEnabled("home"));
  }

  const activateBusinessMetrics = () => {
    const promise = axios.get(`${process.env.REACT_APP_BACKEND_URL}/get_metrics`, {params : {securityKey: securityKey, dbName: databases[0].name}});
    promise.then((response) => {
        console.log(response.data);
        dispatch(setMetricsTable(response.data));
      },
      (error) => {
        console.log(error);
      }
    );
    dispatch(setMenuEnabled("metrics"));
  }

  const activateExamples = () => {
    dispatch(setMenuEnabled("examples"));
  }

const nav = [
  { text: "Home", link: "#!", icon: "home" , onClick: () => activateHomeMenu()},
  { text: "Databases", link: "#!", icon: "database", onClick: () => activateDatabaseMenu()},
  { text: "Metrics Catalogue", link: "#!", icon: "chart line", onClick: () => activateBusinessMetrics()},
  { text: "Examples", link: "#!", icon: "book", onClick: () => {activateExamples("examples")}},
  // { text: "Settings", link: "#!", icon: "setting", onClick: () => {dispatch(setMenuEnabled("settings"))} },
  // { text: "My Queries", link: "#!", icon: "user", onClick: () => {dispatch(setMenuEnabled("queries"))} },
  // { text: "Shared", link: "#!", icon: "book", onClick: () => {dispatch(setMenuEnabled("shared"))}},
];

  return (
    <Grid columns={2}>
    <Grid.Column width={4}>
      <div className={"optionbar collapse"}>
        <ul>
          {nav.map((item,index) => (
            <li key={item.text} onClick={()=>{handleClick(index, item.onClick)}}>
              <a href="#!" className={activeIndex === index ? "active" : ""}>
                <span className="icon">
                <Icon name={item.icon}/>
                </span>
                <span className="title">{item.text}</span>
              </a>
            </li>
          ))}
        </ul>
        <Image src={logo} size="tiny" className="optionbar_logo"/>
      </div>
      </Grid.Column>  
      <Grid.Column width={12}>
        <Explorerbar/>
        </Grid.Column>
    </Grid>

  );
};
export default Optionsbar;
